export class WhiteLabel {
    amountOfUsers: number = -1;
    organisations: any[] = [];
    signingsBundle: any;
    signingBundle: any[] = [];
    whiteLabel: any;
}
